import { cloneDeep, concat, get, isEmpty } from 'lodash';
import { Page_Size } from '../../../../../Components/helper';
import type from './DamFolder.type';

const initialState = {
  damProductFolderList: [],
  totalFolderCount: 0,
  filterValues: {
    pageIndex: 1,
    pageSize: Page_Size,
  },
  fileFilterValues: {
    colourTheme: [],
    primaryColour: [],
    secondaryColour: [],
    fileType: [],
    campaignType: [],
    licenceType: [],
    locationType: [],
    modelName: [],
    assignUnassigned: [],
    tags: [],
    dynamicDropdown: [],
  },
};

const DamProductFolderReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.SET_PRODUCT_FOLDERS:
      const updatedArchivedArry = cloneDeep(setArrayByCase(state.damProductFolderList, action.payload));
      return {
        ...state,
        damProductFolderList: updatedArchivedArry,
        totalFolderCount: action?.payload?.totalCount,
      };
    case type.DAM_PRODUCT_FOLDER_SET_FILTER_SORT_DATA:
      return {
        ...state,
        filterValues: { ...state.filterValues, ...action.payload },
      };
    case type.DAM_PRODUCT_FOLDER_FILES_SET_FILTER_SORT_DATA:
      return {
        ...state,
        fileFilterValues: { ...state.fileFilterValues, ...action.payload },
      };
    default:
      return state;
  }
};

const setArrayByCase = (array, payload) => {
  let newArray;
  if (!isEmpty(get(payload, 'searchText')) && get(payload, 'isScrolled')) {
    newArray = [...array, ...payload.data];
  } else if (!isEmpty(get(payload, 'searchText'))) {
    newArray = payload.data;
  } else if (get(payload, 'isScrolled')) {
    newArray = concat(array, payload.data);
  } else {
    newArray = payload.data;
  }
  return newArray;
};

export default DamProductFolderReducer;
